/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_portalOfficeHospitalListing_requestGetPortalOfficeHospitalListing } from '../models/api_portalOfficeHospitalListing_requestGetPortalOfficeHospitalListing';
import type { api_portalOfficeHospitalListing_requestGetPortalOfficeHospitalListingGroupByListingStatus } from '../models/api_portalOfficeHospitalListing_requestGetPortalOfficeHospitalListingGroupByListingStatus';
import type { api_portalOfficeHospitalListing_requestGetPortalOfficeHospitalListingPublic } from '../models/api_portalOfficeHospitalListing_requestGetPortalOfficeHospitalListingPublic';
import type { api_portalOfficeHospitalListing_requestGetPortalOfficeHospitalListingPublicForNonMember } from '../models/api_portalOfficeHospitalListing_requestGetPortalOfficeHospitalListingPublicForNonMember';
import type { api_portalOfficeHospitalListing_requestSavePortalOfficeHospitalListing } from '../models/api_portalOfficeHospitalListing_requestSavePortalOfficeHospitalListing';
import type { api_portalOfficeHospitalListing_requestSearchPortalOfficeHospitalListings } from '../models/api_portalOfficeHospitalListing_requestSearchPortalOfficeHospitalListings';
import type { api_portalOfficeHospitalListing_requestSearchPortalOfficeHospitalListingsForNonMember } from '../models/api_portalOfficeHospitalListing_requestSearchPortalOfficeHospitalListingsForNonMember';
import type { api_portalOfficeHospitalListing_requestSearchPortalOfficeHospitalListingsUseEngine } from '../models/api_portalOfficeHospitalListing_requestSearchPortalOfficeHospitalListingsUseEngine';
import type { api_portalOfficeHospitalListing_requestSearchPortalOfficeHospitalListingsUseEngineForNonMember } from '../models/api_portalOfficeHospitalListing_requestSearchPortalOfficeHospitalListingsUseEngineForNonMember';
import type { api_portalOfficeHospitalListing_requestUpdatePortalOfficeHospitalListingPublishedAt } from '../models/api_portalOfficeHospitalListing_requestUpdatePortalOfficeHospitalListingPublishedAt';
import type { api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListing } from '../models/api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListing';
import type { api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListingGroupByListingStatus } from '../models/api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListingGroupByListingStatus';
import type { api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListingPublic } from '../models/api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListingPublic';
import type { api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListingPublicForNonMember } from '../models/api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListingPublicForNonMember';
import type { api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListingSearchFilters } from '../models/api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListingSearchFilters';
import type { api_portalOfficeHospitalListing_responseSavePortalOfficeHospitalListing } from '../models/api_portalOfficeHospitalListing_responseSavePortalOfficeHospitalListing';
import type { api_portalOfficeHospitalListing_responseSearchPortalOfficeHospitalListings } from '../models/api_portalOfficeHospitalListing_responseSearchPortalOfficeHospitalListings';
import type { api_portalOfficeHospitalListing_responseSearchPortalOfficeHospitalListingsForNonMember } from '../models/api_portalOfficeHospitalListing_responseSearchPortalOfficeHospitalListingsForNonMember';
import type { api_portalOfficeHospitalListing_responseSearchPortalOfficeHospitalListingsUseEngine } from '../models/api_portalOfficeHospitalListing_responseSearchPortalOfficeHospitalListingsUseEngine';
import type { api_portalOfficeHospitalListing_responseSearchPortalOfficeHospitalListingsUseEngineForNonMember } from '../models/api_portalOfficeHospitalListing_responseSearchPortalOfficeHospitalListingsUseEngineForNonMember';
import type { api_portalOfficeHospitalListing_responseUpdatePortalOfficeHospitalListingPublishedAt } from '../models/api_portalOfficeHospitalListing_responseUpdatePortalOfficeHospitalListingPublishedAt';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PortalOfficeHospitalListingService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get PortalOfficeHospitalListing
     * 医療機関掲載情報取得 ※非公開の掲載情報も取得するため、PortalStaffからCallする事
     * @returns api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListing responseGetPortalOfficeHospitalListing
     * @throws ApiError
     */
    public postPortalOfficeHospitalListingGet({
        body,
    }: {
        /**
         * requestGetPortalOfficeHospitalListing
         */
        body: api_portalOfficeHospitalListing_requestGetPortalOfficeHospitalListing,
    }): CancelablePromise<api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListing> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_hospital_listing/get',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get PortalOfficeHospitalListing
     * Get PortalOfficeHospitalListing
     * @returns api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListingGroupByListingStatus responseGetPortalOfficeHospitalListingGroupByListingStatus
     * @throws ApiError
     */
    public postPortalOfficeHospitalListingGetGroupByListingStatus({
        body,
    }: {
        /**
         * requestGetPortalOfficeHospitalListingGroupByListingStatus
         */
        body: api_portalOfficeHospitalListing_requestGetPortalOfficeHospitalListingGroupByListingStatus,
    }): CancelablePromise<api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListingGroupByListingStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_hospital_listing/get_group_by_listing_status',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Public PortalOfficeHospitalListing by PortalOfficeId
     * 公開中の医療機関掲載情報を1件取得する
     * @returns api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListingPublic responseGetPortalOfficeHospitalListingPublic
     * @throws ApiError
     */
    public postPortalOfficeHospitalListingGetPublic({
        body,
    }: {
        /**
         * requestGetPortalOfficeHospitalListingPublic
         */
        body: api_portalOfficeHospitalListing_requestGetPortalOfficeHospitalListingPublic,
    }): CancelablePromise<api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListingPublic> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_hospital_listing/get_public',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Public PortalOfficeHospitalListing for Non-members by PortalOfficeId
     * 非会員用に、公開中の医療機関掲載情報を1件取得する
     * @returns api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListingPublicForNonMember responseGetPortalOfficeHospitalListingPublicForNonMember
     * @throws ApiError
     */
    public postPortalOfficeHospitalListingGetPublicForNonMember({
        body,
    }: {
        /**
         * requestGetPortalOfficeHospitalListingPublicForNonMember
         */
        body: api_portalOfficeHospitalListing_requestGetPortalOfficeHospitalListingPublicForNonMember,
    }): CancelablePromise<api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListingPublicForNonMember> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_hospital_listing/get_public_for_non_member',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Search filters
     * 医療機関掲載情報の検索条件を取得する
     * @returns api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListingSearchFilters responseGetPortalOfficeHospitalListingSearchFilters
     * @throws ApiError
     */
    public postPortalOfficeHospitalListingGetSearchFilter(): CancelablePromise<api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListingSearchFilters> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_hospital_listing/get_search_filter',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Search filters
     * 非会員用に、医療機関掲載情報の検索条件を取得する
     * @returns api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListingSearchFilters responseGetPortalOfficeHospitalListingSearchFilters
     * @throws ApiError
     */
    public postPortalOfficeHospitalListingGetSearchFilterForNonMember(): CancelablePromise<api_portalOfficeHospitalListing_responseGetPortalOfficeHospitalListingSearchFilters> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_hospital_listing/get_search_filter_for_non_member',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Portal Office Hospital Listing Published Date
     * Updates the published date of a portal office hospital listing to the current time
     * @returns api_portalOfficeHospitalListing_responseUpdatePortalOfficeHospitalListingPublishedAt Successful response
     * @throws ApiError
     */
    public postPortalOfficeHospitalListingPublish({
        body,
    }: {
        /**
         * requestUpdatePortalOfficeHospitalListingPublishedAt
         */
        body: api_portalOfficeHospitalListing_requestUpdatePortalOfficeHospitalListingPublishedAt,
    }): CancelablePromise<api_portalOfficeHospitalListing_responseUpdatePortalOfficeHospitalListingPublishedAt> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_hospital_listing/publish',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Portal Office Hospital Listing Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Save PortalOfficeHospitalListing
     * 医療機関掲載情報保存（id=nullでInsert、id指定でUpdate）
     * @returns api_portalOfficeHospitalListing_responseSavePortalOfficeHospitalListing responseSavePortalOfficeHospitalListing
     * @throws ApiError
     */
    public postPortalOfficeHospitalListingSave({
        body,
    }: {
        /**
         * requestSavePortalOfficeHospitalListing
         */
        body: api_portalOfficeHospitalListing_requestSavePortalOfficeHospitalListing,
    }): CancelablePromise<api_portalOfficeHospitalListing_responseSavePortalOfficeHospitalListing> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_hospital_listing/save',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Search PortalOfficeHospitalListing
     * 医療機関掲載情報を事業所名または医療機関コードで検索する
     * @returns api_portalOfficeHospitalListing_responseSearchPortalOfficeHospitalListings responseSearchPortalOfficeHospitalListings
     * @throws ApiError
     */
    public postPortalOfficeHospitalListingSearch({
        body,
    }: {
        /**
         * requestSearchPortalOfficeHospitalListings
         */
        body: api_portalOfficeHospitalListing_requestSearchPortalOfficeHospitalListings,
    }): CancelablePromise<api_portalOfficeHospitalListing_responseSearchPortalOfficeHospitalListings> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_hospital_listing/search',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Search PortalOfficeHospitalListing use rest-schedule-engine
     * 検索エンジンをコールして医療機関掲載情報を検索する
     * @returns api_portalOfficeHospitalListing_responseSearchPortalOfficeHospitalListingsUseEngine responseSearchPortalOfficeHospitalListingsUseEngine
     * @throws ApiError
     */
    public postPortalOfficeHospitalListingSearchEngine({
        body,
    }: {
        /**
         * requestSearchPortalOfficeHospitalListingsUseEngine
         */
        body: api_portalOfficeHospitalListing_requestSearchPortalOfficeHospitalListingsUseEngine,
    }): CancelablePromise<api_portalOfficeHospitalListing_responseSearchPortalOfficeHospitalListingsUseEngine> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_hospital_listing/search_engine',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Search PortalOfficeHospitalListing use rest-schedule-engine for Non-members
     * 非会員用に、検索エンジンをコールして医療機関掲載情報を検索する
     * @returns api_portalOfficeHospitalListing_responseSearchPortalOfficeHospitalListingsUseEngineForNonMember responseSearchPortalOfficeHospitalListingsUseEngineForNonMember
     * @throws ApiError
     */
    public postPortalOfficeHospitalListingSearchEngineForNonMember({
        body,
    }: {
        /**
         * requestSearchPortalOfficeHospitalListingsUseEngineForNonMember
         */
        body: api_portalOfficeHospitalListing_requestSearchPortalOfficeHospitalListingsUseEngineForNonMember,
    }): CancelablePromise<api_portalOfficeHospitalListing_responseSearchPortalOfficeHospitalListingsUseEngineForNonMember> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_hospital_listing/search_engine_for_non_member',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Search PortalOfficeHospitalListing for Non-members
     * 非会員用に、医療機関掲載情報を事業所名または医療機関コードで検索する
     * @returns api_portalOfficeHospitalListing_responseSearchPortalOfficeHospitalListingsForNonMember responseSearchPortalOfficeHospitalListingsForNonMember
     * @throws ApiError
     */
    public postPortalOfficeHospitalListingSearchForNonMember({
        body,
    }: {
        /**
         * requestSearchPortalOfficeHospitalListingsForNonMember
         */
        body: api_portalOfficeHospitalListing_requestSearchPortalOfficeHospitalListingsForNonMember,
    }): CancelablePromise<api_portalOfficeHospitalListing_responseSearchPortalOfficeHospitalListingsForNonMember> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_hospital_listing/search_for_non_member',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
